export class WlOpenModal extends Event {
    static type: string = 'wl-open-modal';

    constructor() {
        super(WlOpenModal.type, {bubbles: true, composed: true});
    }
}
